module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MU-b8a4746a6ded51db8ed36516237bb173.png";